import React from 'react';
import PropTypes from 'prop-types';
import { Identifier } from 'web-ui-components/lib/typography/modifiers';
import { VerticalReviewTable } from 'web-ui-components/lib/layout/tables';
import { map } from 'lodash';

import { newPayeeDetailsPropTypes } from '../../payees/states/addPayeeSuccess/propTypes';
import { contentPropTypes } from '../../payees/components/AddNewPayeeSuccessPage/index.content';
import { payeePropTypes as viewPayeeDetailsPropTypes } from '../../managePayee/states/propTypes';
import { contentPropTypes as viewPayeeContentPropTypes } from '../../managePayee/components/viewPayee/index.content';

const getPayeeDetails = (newPayeeDetails, content) =>
	map(newPayeeDetails, (rowValue, rowKey) =>
		rowValue
			? {
					headerText: content[rowKey],
					cellText: <Identifier.Breaking>{rowValue}</Identifier.Breaking>,
			  }
			: ''
	);

const Table = ({ newPayeeDetails, content }) => (
	<VerticalReviewTable data={getPayeeDetails(newPayeeDetails, content)} />
);

Table.propTypes = {
	content: PropTypes.oneOfType([PropTypes.shape(contentPropTypes), PropTypes.shape(viewPayeeContentPropTypes)])
		.isRequired,
	newPayeeDetails: PropTypes.oneOfType([
		PropTypes.shape(newPayeeDetailsPropTypes),
		PropTypes.shape(viewPayeeDetailsPropTypes),
	]).isRequired,
};

export default Table;
